<div class="fluid grid">
  <div class="col-12 mt-4">
    <span class="p-float-label">
      <input id="smtng-input" type="text" (keyup)="onKeyPress($event)" pInputText [(ngModel)]="something" [style]="{'width':'100%', 'text-align':'center'}" />
      <label for="float-input">{{header}}</label>
    </span>
  </div>
</div>

<div class="grid">
  <div class="col-12">
    <p-table id="searchResultTable" #searchResultTable
             [value]="companies"
             [loading]="loading"
             [rows]="rows"
             styleClass="p-datatable p-datatable-gridlines p-datatable-customers"
             dataKey="CLIHASH"
             [paginator]="true"
             selectionMode="single"
             [(selection)]="selection"
             [rowHover]="true"
             (onRowSelect)="doSearchClientSelect($event)"
             >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 25%">Компания </th>
          <th style="width: 20%">Контакт </th>
          <th style="width: 10%">Город </th>
          <th style="width: 10%">Телефон </th>
          <th style="width: 20%">E-mail </th>
          <th style="width: 15%">Группа </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-companies>
        <tr [pSelectableRow]="companies">
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
            <a [routerLink]="['/edit-client', companies.CLIID]">{{companies.CLIENTSNIKNAME}}</a>
          </td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.PERSONFNAME}} {{companies.PERSONLNAME}}</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.CLIENTCITY}}</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.PERSONCPHONE}}</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.PERSONEMAIL}}</td>
          <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{companies.CASTCATNAME}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">Пока ничего не найдено...</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
